import { Box } from "@mui/system";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import {
  allFilters,
  filterHeaderSearchLinkedinIndustry,
} from "../../redux/actions/filterActions";
import { filterHeaderLinkedinIndustry } from "../../redux/store/storeConstants";
import { filterKeys } from "../../utils/constants/filters";
import { leadsEndpoints } from "../../utils/constants/httpConstants";
import { CustomAutoComplete } from "../Autocomplete";
import { styles } from "./styles";
import Checkbox from "../Buttons/Checkbox/Checkbox";
import { STRINGS } from "./strings";

const CompanyLinkedinIndustryFilter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const allFiltersSelector = useSelector((state) => state?.allFilters?.payload);
  const selectedLinkedinIndustryFilter = useSelector(
    (state) => state.filterHeaderLinkedinIndustry?.payload
  );

  const handleLinkedinIndustryChange = (item, filter) => {
    let payload = {
      ...selectedLinkedinIndustryFilter,
      [item]: !selectedLinkedinIndustryFilter[item],
      isKnown: false,
      isUnknown: false,
    };

    // clear data if column is empty.
    const unCheckPayload = {};
    if (!payload?.anyOf) {
      unCheckPayload[filter] = [];
    }
    if (!payload?.notAnyOf) {
      unCheckPayload[filter + "_not"] = [];
    }
    // clear data if column is empty.

    dispatch(
      allFilters({
        ...unCheckPayload,
        exist_fields: [...allFiltersSelector.exist_fields].filter(
          (e) => e !== filter
        ),
        not_exist_fields: [...allFiltersSelector.not_exist_fields].filter(
          (e) => e !== filter
        ),
      })
    );

    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...allFiltersSelector,
        ...unCheckPayload,
        exist_fields: [...allFiltersSelector.exist_fields].filter(
          (e) => e !== filter
        ),
        not_exist_fields: [...allFiltersSelector.not_exist_fields].filter(
          (e) => e !== filter
        ),
      }).toString(),
    });

    dispatch(filterHeaderSearchLinkedinIndustry(payload));
  };

  const handleExistFields = (
    existing_type,
    filter,
    queryInsertKey,
    notFilterKey
  ) => {
    // "isKnown",
    // "linkedin_industry",
    // "exist_fields",
    // "not_exist_fields"
    // existing_type = isKnown/ isUnknown
    // filter = linkedin_industry

    let payload = {
      ...filterHeaderLinkedinIndustry?.payload,
      [existing_type]: !selectedLinkedinIndustryFilter[existing_type],
    };

    dispatch(filterHeaderSearchLinkedinIndustry(payload));
    if (payload?.[existing_type]) {
      const queryPayload = {
        [queryInsertKey]: [...allFiltersSelector?.[queryInsertKey], filter],
        [notFilterKey]: [...allFiltersSelector?.[notFilterKey]].filter(
          (e) => e !== filter
        ),
        [filter]: [],
        [filter + "_not"]: [],
      };

      dispatch(allFilters(queryPayload));
      navigate({
        pathname: location.pathname,
        search: createSearchParams({
          ...allFiltersSelector,
          ...queryPayload,
        }).toString(),
      });
    } else {
      const queryPayload = {
        [queryInsertKey]: [...allFiltersSelector?.[queryInsertKey]].filter(
          (e) => e !== filter
        ),
      };
      dispatch(allFilters(queryPayload));
      navigate({
        pathname: location.pathname,
        search: createSearchParams({
          ...allFiltersSelector,
          ...queryPayload,
        }).toString(),
      });
    }
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.filterContainer}>
        <div style={styles.jobTitleHead}>
          <Checkbox
            checked={
              selectedLinkedinIndustryFilter?.anyOf == undefined
                ? selectedLinkedinIndustryFilter?.payload?.anyOf
                : selectedLinkedinIndustryFilter?.anyOf
            }
            onClick={() =>
              handleLinkedinIndustryChange(
                "anyOf",
                filterKeys.linkedin_industry
              )
            }
            label={STRINGS.IS_ANY_OF}
          />
        </div>
        {selectedLinkedinIndustryFilter.anyOf ? (
          <Box>
            <CustomAutoComplete
              filter={filterKeys.linkedin_industry}
              type=""
              endPoint={leadsEndpoints.getIndustryLinkedInFilters}
            />
          </Box>
        ) : null}
        <div style={styles.jobTitleHead}>
          <Checkbox
            checked={
              selectedLinkedinIndustryFilter?.notAnyOf == undefined
                ? selectedLinkedinIndustryFilter?.payload?.notAnyOf
                : selectedLinkedinIndustryFilter?.notAnyOf
            }
            onClick={() =>
              handleLinkedinIndustryChange(
                "notAnyOf",
                filterKeys.linkedin_industry
              )
            }
            label={STRINGS.IS_NOT_ANY_OF}
          />
        </div>
        {selectedLinkedinIndustryFilter.notAnyOf ? (
          <Box>
            <CustomAutoComplete
              filter={filterKeys.linkedin_industry}
              type="_not"
              endPoint={leadsEndpoints.getIndustryLinkedInFilters}
            />
          </Box>
        ) : null}
        <div style={styles.jobTitleHead}>
          <Checkbox
            checked={
              selectedLinkedinIndustryFilter?.isKnown == undefined
                ? selectedLinkedinIndustryFilter?.payload?.isKnown
                : selectedLinkedinIndustryFilter?.isKnown
            }
            onClick={() =>
              handleExistFields(
                "isKnown",
                // filterKeys.linkedin_industry,
                "company_linkedin_industry",
                "exist_fields",
                "not_exist_fields"
              )
            }
            label={STRINGS.IS_KNOWN}
          />
        </div>

        <div style={styles.jobTitleHead}>
          <Checkbox
            checked={
              selectedLinkedinIndustryFilter?.isUnknown == undefined
                ? selectedLinkedinIndustryFilter?.payload?.isUnknown
                : selectedLinkedinIndustryFilter?.isUnknown
            }
            onClick={() =>
              handleExistFields(
                "isUnknown",
                // filterKeys.linkedin_industry,
                "company_linkedin_industry",
                "not_exist_fields",
                "exist_fields"
              )
            }
            label={STRINGS.IS_UNKNOWN}
          />
        </div>
      </Box>
    </Box>
  );
};

export default CompanyLinkedinIndustryFilter;
